<template lang="pug">
  main
    // Left panel content
    h1 Create a Course
    aside(class="sidebar courses-available")
      h2 Current STEM Courses Available
      ul
        li
          a(href="https://circuits1.hvullc.com/") <strong>Circuits 1</strong>: Introduction to Electrical Circuits
          span &nbsp; taught by Tim Hanshaw (currently this course is offered at no charge)

    // Right panel content
    div(class="course-container")
      section(class="main-container just-text")
        div
          h1 For S.T.E.M. Course Creators &amp; Administrators
          p <strong><em>The HVU learning management system (LMS) was created with STEM courses in mind.</em></strong>
          p As administrators, course creators can <strong>build a course and have complete control over the content of the course</strong>. Administrators create and organize the units, lessons, and sub-lessons in a class. They populate the course with reference materials, videos, and examples, and create practice problems and quizzes.
          p Administrators are also <strong>responsible for approving and enrolling group leaders</strong> in the course and approving problems created by the group leaders. 
          p Course administrators <strong>have access to detailed metrics relative to the progress of ALL of the students</strong> in their course. (Group leaders added by administrators only have access to the student metrics of their own group.) The data available includes:
          <h3></h3>
          ul
            li The <strong>types of activities (passive or active)</strong> the student is engaging in
            li The <strong>level of difficulty of the practice problems</strong> the student is solving
            li The <strong>level to which the student is engaging with the active materials</strong> by providing data relative to problems “attempted” and problems “completed”. Comparing these numbers allows an administrator (or group leader) to assess whether the student is successfully solving problems independently or simply using the assistance materials to walk through problems.
            li The student’s <strong>quiz scores</strong>

          p The goal of providing these metrics is to allow administrators to <strong>readily assess student progress</strong> and <strong>suggest more productive activities</strong> to struggling students. 
          p <em><strong>Interested in using the HVU Learning Management System to design your STEM course?</strong> <a href="mailto:feedback@hvullc.com">Contact us today</a> to request Administrative access and assistance in setting up a course for your students.</em>
</template>

<script>
export default {
  name: "CreateCourse"
};
</script>
